import { DataBean } from "../../DataBean";


export class HealthTimeUnit extends DataBean {


    public async getHealthTimeUnitCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthTimeUnitCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}